<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'>
      </el-table-column>
      <el-table-column
        prop= 'labels'
        label= '标签'>
      </el-table-column>
      <el-table-column
        prop= 'minDays'
        label= '生长时间'
        width= '100'>
        <template slot-scope='scope'>
          {{ scope.row.minDays }}-{{ scope.row.maxDays }}天
        </template>
      </el-table-column>
      <el-table-column
        prop= 'minLiveTemperature'
        label= '存活温度'
        width= '100'>
        <template slot-scope='scope'>
          {{ scope.row.minLiveTemperature }}-{{ scope.row.maxLiveTemperature }}℃
        </template>
      </el-table-column>
      <el-table-column
        prop= 'minGrowthTemperature'
        label= '适宜温度'
        width= '100'>
        <template slot-scope='scope'>
          {{ scope.row.minGrowthTemperature }}-{{ scope.row.maxGrowthTemperature }}℃
        </template>
      </el-table-column>
      <el-table-column
        prop= 'serialNo'
        label= '品种'
        width= '160'>
      </el-table-column>
      <el-table-column
        prop= 'typeAgriculture'
        label= '农业分类'
        width= '100'>
        <template slot-scope='scope'>
          <el-button type='danger' size='small' v-if="scope.row.typeAgriculture===10">果蔬</el-button>
          <el-button type='warning' size='small' v-if="scope.row.typeAgriculture===20">花卉</el-button>
          <el-button type='primary' size='small' v-if="scope.row.typeAgriculture===30">畜牧</el-button>
          <el-button type='success' size='small' v-if="scope.row.typeAgriculture===40">水产</el-button>
          <el-button type='info' size='small' v-if="scope.row.typeAgriculture===50">其他</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'habitWater'
        label= '喜好'
        width= '210'>
        <template slot-scope='scope'>
          {{ scope.row.habitWater }},{{ scope.row.habitTemperature }},{{ scope.row.habitLight }},{{ scope.row.habitSoilPh }},{{ scope.row.habitSoilWater }}
        </template>
      </el-table-column>
      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '230'>
        <template slot-scope='scope'>
          <el-button @click='manageBiotaImages(scope.row)' type='text' size='small' style="color: #64CA7E">图例管理</el-button>
          <el-button @click='manageBiotaGrowthStage(scope.row)' type='text' size='small' style="color: #64CA7E">生长阶段</el-button>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible" top="0px">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="别名" :label-width="formLabelWidth" prop="aliasName">
              <el-input v-model="form.aliasName" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="品种" :label-width="formLabelWidth" prop="serialNo">
              <el-input v-model="form.serialNo" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="标签" :label-width="formLabelWidth" prop="labels">
              <el-input v-model="form.labels" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="生长最短时间" :label-width="formLabelWidth" prop="minDays">
              <el-input type="number" v-model.number="form.minDays" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="生长最长时间" :label-width="formLabelWidth" prop="maxDays">
              <el-input type="number" v-model.number="form.maxDays" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="存活最低温度" :label-width="formLabelWidth" prop="minLiveTemperature">
              <el-input type="number" v-model.number="form.minLiveTemperature" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="存活最高温度" :label-width="formLabelWidth" prop="maxLiveTemperature">
              <el-input type="number" v-model.number="form.maxLiveTemperature" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="生长最低温度" :label-width="formLabelWidth" prop="minGrowthTemperature">
              <el-input type="number" v-model.number="form.minGrowthTemperature" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="生长最高温度" :label-width="formLabelWidth" prop="maxGrowthTemperature">
              <el-input type="number" v-model.number="form.maxGrowthTemperature" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="农业分类" :label-width="formLabelWidth" prop="typeAgriculture">
          <el-radio-group v-model="form.typeAgriculture" size="medium">
            <el-radio-button label=10>果蔬</el-radio-button>
            <el-radio-button label=20>花卉</el-radio-button>
            <el-radio-button label=30>畜牧</el-radio-button>
            <el-radio-button label=40>水产</el-radio-button>
            <el-radio-button label=50>其他</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-row>
          <el-col :span="3">
            <el-form-item label="界" label-width="60px" prop="familiesGenera1">
              <el-input v-model="form.familiesGenera1" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="门" label-width="60px" prop="familiesGenera2">
              <el-input v-model="form.familiesGenera2" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="纲" label-width="60px" prop="familiesGenera3">
              <el-input v-model="form.familiesGenera3" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="目" label-width="60px" prop="familiesGenera4">
              <el-input v-model="form.familiesGenera4" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="科" label-width="60px" prop="familiesGenera5">
              <el-input v-model="form.familiesGenera5" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="属" label-width="60px" prop="familiesGenera6">
              <el-input v-model="form.familiesGenera6" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="种" label-width="60px" prop="familiesGenera7">
              <el-input v-model="form.familiesGenera7" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="特征" :label-width="formLabelWidth" prop="feature">
          <el-input v-model="form.feature" autocomplete="off"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="喜好湿度" :label-width="formLabelWidth" prop="habitWater">
              <el-radio-group v-model="form.habitWater" size="medium">
                <el-radio-button label='喜湿'>喜湿</el-radio-button>
                <el-radio-button label='喜干'>喜干</el-radio-button>
                <el-radio-button label='普通'>普通</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="喜好光照" :label-width="formLabelWidth" prop="habitLight">
              <el-radio-group v-model="form.habitLight" size="medium">
                <el-radio-button label='喜阴'>喜阴</el-radio-button>
                <el-radio-button label='喜阳'>喜阳</el-radio-button>
                <el-radio-button label='普通'>普通</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="喜好土壤pH" :label-width="formLabelWidth" prop="habitSoilPh">
              <el-radio-group v-model="form.habitSoilPh" size="medium">
                <el-radio-button label='耐酸'>耐酸</el-radio-button>
                <el-radio-button label='耐碱'>耐碱</el-radio-button>
                <el-radio-button label='普通'>普通</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="喜好土壤湿度" :label-width="formLabelWidth" prop="habitSoilWater">
              <el-radio-group v-model="form.habitSoilWater" size="medium">
                <el-radio-button label='耐涝'>耐涝</el-radio-button>
                <el-radio-button label='耐旱'>耐旱</el-radio-button>
                <el-radio-button label='普通'>普通</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="喜好温度" :label-width="formLabelWidth" prop="habitTemperature">
              <el-radio-group v-model="form.habitTemperature" size="medium">
                <el-radio-button label='喜高温'>喜高温</el-radio-button>
                <el-radio-button label='喜温暖'>喜温暖</el-radio-button>
                <el-radio-button label='喜寒冷'>喜寒冷</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="描述" :label-width="formLabelWidth" prop="descr">
          <el-input type="textarea" v-model="form.descr" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="封面图像" :label-width="formLabelWidth" prop="imageMd5">
          <el-upload class="upload-demo" drag action="#" accept="png,jpg,jpeg" :limit=1 :http-request="uploadImage" :file-list="fileList">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="curRow.name + '  生长条件管理'" :visible.sync="dialogBiotaGrowthStageVisible" width="98%" top="0" :fullscreen="true" :modal="false">
      <BiotaGrowthStage :biotaId="curRow.id"></BiotaGrowthStage>
    </el-dialog>
    <el-dialog :title="curRow.name + '  图例管理'" :visible.sync="dialogBiotaImagesVisible" width="600px" :fullscreen="false" :modal="true">
      <el-upload class="upload-demo" action="#" :file-list="fileListBiotaImages" :http-request="uploadBiotaImage" list-type="picture" :on-remove="removeBiotaImages">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
      </el-upload>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
import BiotaGrowthStage from '../biotaGrowthStage/Index.vue'
export default {
  components: {
    BiotaGrowthStage
  },
  data () {
    return {
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        name: null,
        labels: null,
        descr: null,
        imageMd5: null,
        minDays: null,
        maxDays: null,
        minLiveTemperature: null,
        maxLiveTemperature: null,
        minGrowthTemperature: null,
        maxGrowthTemperature: null,
        serialNo: null,
        aliasName: null,
        typeAgriculture: null,
        familiesGenera1: null,
        familiesGenera2: null,
        familiesGenera3: null,
        familiesGenera4: null,
        familiesGenera5: null,
        familiesGenera6: null,
        familiesGenera7: null,
        feature: null,
        habitWater: null,
        habitTemperature: null,
        habitLight: null,
        habitSoilPh: null,
        habitSoilWater: null
      },
      rules: {
        minDays: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}],
        maxDays: [{type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur']}],
        minLiveTemperature: [{type: 'number', message: '需要小数数据类型', trigger: ['change', 'blur']}],
        maxLiveTemperature: [{type: 'number', message: '需要小数数据类型', trigger: ['change', 'blur']}],
        minGrowthTemperature: [{type: 'number', message: '需要小数数据类型', trigger: ['change', 'blur']}],
        maxGrowthTemperature: [{type: 'number', message: '需要小数数据类型', trigger: ['change', 'blur']}]
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      fileList: [],
      apiUrl: '',
      dialogBiotaGrowthStageVisible: false,
      curRow: {},
      dialogBiotaImagesVisible: false,
      fileListBiotaImages: []
    }
  },
  created () {
    this.apiUrl = this.$global.apiUrl
    this.query()
  },
  methods: {
    manageBiotaImages (row) {
      this.curRow = {...row}
      let that = this
      this.fileListBiotaImages = []
      requestService.get(`/biotaImages/listPage?current=${that.current}&pageSize=65535&biotaId=${row.id}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.dialogBiotaImagesVisible = true
        for (let item of res.data.body.records) {
          that.fileListBiotaImages.push({name: item.fileMd5, url: this.apiUrl + '/file/getOneByByte?md5=' + item.fileMd5})
        }
      })
    },
    uploadBiotaImage (file) {
      let that = this
      let formData = new FormData()
      formData.append('file', file.file)
      requestService.post('/file/add/single', formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.fileListBiotaImages.push({name: res.data.body.md5, url: this.apiUrl + '/file/getOneByByte?md5=' + res.data.body.md5})
        requestService.post('/biotaImages/add', {biotaId: that.curRow.id, name: res.data.body.md5, fileMd5: res.data.body.md5}, {headers: {'Content-Type': 'application/json'}}).then((res) => {
        })
      })
    },
    removeBiotaImages (file) {
      let params = {
        biotaId: this.curRow.id,
        fileMd5: file.name
      }
      requestService.post('/biotaImages/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
      })
    },
    manageBiotaGrowthStage (row) {
      this.curRow = {...row}
      this.dialogBiotaGrowthStageVisible = true
    },
    uploadImage (file) {
      let that = this
      let formData = new FormData()
      formData.append('file', file.file)
      requestService.post('/file/add/single', formData, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.form.imageMd5 = res.data.body.md5
        console.log(that.form)
      })
    },
    del (row) {
      let that = this
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/biota/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/biota/listPage?current=${that.current}&pageSize=${that.pageSize}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.fileList = []
      if (this.form.imageMd5) {
        this.fileList.push({name: this.form.imageMd5, url: this.apiUrl + '/file/getOneByByte?md5=' + this.form.imageMd5})
      }
      console.log(this.fileList)
      this.dialogFormVisible = true
    },
    digAdd () {
      this.form = {}
      this.fileList = []
      this.dialogFormVisible = true
    },
    submitForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        console.log(that.form)
        if (valid) {
          that.dialogFormVisible = false
          console.log('add')
          let url = '/biota/add'
          if (that.form.id) {
            url = '/biota/edit'
          }
          requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/biota/Index.vue